export default "__VITE_ASSET__D6h78DRH__"